export const STATUS_CONFIG = {
  pending:    { label: '待確認', color: 'bg-yellow-100 text-yellow-700' },
  assigned:   { label: '待接單', color: 'bg-blue-100 text-blue-700' },
  confirmed:  { label: '已接單', color: 'bg-indigo-100 text-indigo-700' },
  preparing:  { label: '備貨中', color: 'bg-orange-100 text-orange-700' },
  delivering: { label: '配送中', color: 'bg-purple-100 text-purple-700' },
  ready:      { label: '待自提', color: 'bg-cyan-100 text-cyan-700' },
  completed:  { label: '已完成', color: 'bg-green-100 text-green-700' },
  cancelled:  { label: '已取消', color: 'bg-gray-100 text-gray-500' }
};

export const BALANCE_LOG_TYPES = {
  commission:   { label: '佣金收入', color: 'text-green-600' },
  recharge:     { label: '充值',     color: 'text-green-600' },
  withdraw:     { label: '提币',     color: 'text-red-500' },
  consume:      { label: '消费',     color: 'text-red-500' },
  transfer_in:  { label: '转入',     color: 'text-green-600' },
  transfer_out: { label: '转出',     color: 'text-red-500' },
};

export const isVipActive = (customer) => {
  if (!customer?.vip_expired_ts) return false;
  return customer.vip_expired_ts > Math.floor(Date.now() / 1000);
};

export const formatVipExpiry = (customer) => {
  if (!customer?.vip_expired_ts) return '未开通';
  return new Date(customer.vip_expired_ts * 1000).toLocaleDateString('zh-CN');
};